import customEventSaga from '../customEvent/customEventSaga';
const createDynamicModuleLoaderCustomEvent = () => ({
    id: 'custom-event',
    sagas: [customEventSaga],
});
export default createDynamicModuleLoaderCustomEvent;
